import {
  DefaultProfile,
} from '../implementations';

const mappers = {
  default_profile: DefaultProfile,
  external_profile: DefaultProfile,
};

export default mappers;
